//COPIED FROM CONFLUENCE

import { getOverride } from '@confluence/meta';
import Placeholder from './placeholder';
// TODO: remove jquery from here and from webpack config once CONFDEV-52616 is done.
// eslint-disable-next-line no-restricted-imports
import $ from 'jquery';
import window from 'window-or-global';
import { bind, trigger } from '@confluence-classic/confluence-event_DO_NOT_USE';
import { getRte } from '../../facades/editor';

function PropertyPanelTextPlaceholder() {
	return {
		name: 'textplaceholder',

		canHandleElement($element) {
			return $element.hasClass('text-placeholder');
		},

		handle(data) {
			if (data.e.type !== 'click' && data.e.type !== 'mouseup') {
				// only activate this panel on click
				return;
			}

			const placeholderTypes = Placeholder.getPlaceholderTypes();
			const placeholderNode = data.containerEl;
			const $placeholderNode = $(placeholderNode);
			const placeholderType = $placeholderNode.attr('data-placeholder-type');

			const buttons = [];

			function changeType(type) {
				if (type === 'default') {
					$placeholderNode.removeAttr('data-placeholder-type');
				} else {
					$placeholderNode.attr('data-placeholder-type', type);
				}
				const button = $(`.text-placeholder-property-panel-type-${type}`);
				button.parent().find('.text-placeholder-property-panel-type-item').removeClass('selected');
				button.addClass('selected');
			}

			function createTypeButton(type, text, tooltip) {
				return {
					className: `text-placeholder-property-panel-type-item text-placeholder-property-panel-type-${type}`,
					text,
					tooltip,
					selected: placeholderType === type,
					click() {
						changeType(type);
					},
				};
			}

			const defaultButton = createTypeButton(
				'default',
				window.tinymce.activeEditor.translate('property.panel.textplaceholder.display.default'),
				window.tinymce.activeEditor.translate(
					'property.panel.textplaceholder.display.default.tooltip',
				),
			);
			defaultButton.selected = !placeholderType;
			buttons.push(defaultButton);

			let currentType;
			for (let i = 0, l = placeholderTypes.length; i < l; i++) {
				currentType = placeholderTypes[i];
				buttons.push(createTypeButton(currentType.type, currentType.label, currentType.tooltip));
			}

			buttons.push(null); // separator

			buttons.push({
				className: 'text-placeholder-property-panel-remove-button',
				text: window.tinymce.activeEditor.translate('property.panel.textplaceholder.remove'),
				click() {
					window.Confluence.PropertyPanel.destroy();
					Placeholder.removePlaceholder($placeholderNode);
				},
			});

			window.Confluence.PropertyPanel.createFromButtonModel(
				'textplaceholder',
				placeholderNode,
				buttons,
				{ anchorIframe: getRte().getEditorFrame() },
			);
		},
	};
}

export default function () {
	const placeholder = PropertyPanelTextPlaceholder();
	window.Confluence.PropertyPanel.TextPlaceholder = placeholder;

	bind('init.rte', () => {
		// defer trigger to ensure any listeners have had a chance to load.
		if (getOverride('content-type') === 'template') {
			trigger('add-handler.property-panel', placeholder);
		}
	});
}
